import { defineComponent as _defineComponent } from 'vue'

export enum LogoType {
  SingleColor = 'SingleColor',
  Rainbow = 'Rainbow',
  Light300 = 'Light300',
  Dark300 = 'Dark300',
  Light200 = 'Light200',
  Dark200 = 'Dark200',
  Light100 = 'Light100',
  Dark100 = 'Dark100',
}
const __default__ = {}

import { currentHostWithProtocol } from '@@/bits/location'
import rainbowLogo from '@@/images/padlet_logo_rainbow.png'
import { uniqueId } from 'lodash-es'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PadletLogo',
  props: {
    darkMode: { type: Boolean, default: false },
    href: { default: undefined },
    type: { default: LogoType.SingleColor }
  },
  setup(__props: any) {



const maskId = uniqueId('mask-')
const clipPathId = uniqueId('clippath-')

return { __sfc: true,LogoType, maskId, clipPathId, currentHostWithProtocol, rainbowLogo }
}

})